import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAccountRoles } from "@/hooks/useAccountRoles";
import type { AccountRole } from "@/lib/accountRoles";

interface RequireAccountRoleProps {
  children: ReactNode;
  role: AccountRole;
  redirectTo: string;
  loadingFallback: ReactNode;
}

export const RequireAccountRole = ({
  children,
  role,
  redirectTo,
  loadingFallback,
}: RequireAccountRoleProps) => {
  const { hasRole, loading } = useAccountRoles();

  if (loading) return loadingFallback;
  if (!hasRole(role)) return <Navigate to={redirectTo} replace />;

  return children;
};
